import { NgModule } from '@angular/core';
import { SharedModule } from '../shared/shared.module';
import { RouterModule } from '@angular/router';

import { HeaderComponent } from './header/header.component';
import { SideNavComponent } from './side-nav/side-nav.component';
import { FooterComponent } from './footer/footer.component';
import { Sidebar_Directives } from '../shared/directives/side-nav.directive';
import { NgSelectModule } from '@ng-select/ng-select';
import { RedmineConnectModule } from '../redmine-connect/redmine-connect.module';

@NgModule({
  imports: [SharedModule, RouterModule, NgSelectModule, RedmineConnectModule],
  exports: [
    HeaderComponent,
    SideNavComponent,
    FooterComponent,
    NgSelectModule,
    Sidebar_Directives,
  ],
  declarations: [
    HeaderComponent,
    SideNavComponent,
    FooterComponent,
    Sidebar_Directives,
  ],
  providers: [],
})
export class TemplateModule {}
